import { all, call, put, select } from 'redux-saga/effects';
import { Api } from '../../lib/api';
import { addToasts, activatePolygon, getTeamReps, selectTeam } from '../../redux';
function* handleActivatePolygon({ payload }) {
    const { teamId, polygonId, repIds, callback } = payload;
    try {
        const [response] = (yield all([
            call(Api.activatePolygon, polygonId),
            repIds.length // TODO: Should we dispatch reassignRepsToPolygons action instead? Yes, that way we can handle licensing errors. That should works. It seems that requests can run in random order which is probably not correct.
                ? call(Api.reassignRepsToPolygons, teamId, { polygon_ids: [polygonId], reps: repIds })
                : null,
        ].filter(Boolean)));
        yield put(activatePolygon.success(response.data));
        // TODO: Do we need to put reassignRepsToPolygons.success here?
        yield put(addToasts([
            {
                type: 'success',
                message: `Polygon #${response.data.data.polygon.polygon_id} is activated.`,
            },
        ]));
        yield call(callback);
    }
    catch (error) { // TODO: catch (error: AxiosError<ActivatePolygonFailurePayload> | Error) { ... } to get the type of the error
        yield put(activatePolygon.failure(error));
        // TODO: handle licensing error if needed. See src/package/redux/sagas/handleReassignRepsToPolygons.ts
    }
    finally {
        const { team } = (yield select(selectTeam));
        if (team?.id) {
            yield put(getTeamReps.request({ teamId: team.id }));
        }
    }
}
export default handleActivatePolygon;
